import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=1641b27a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1641b27a')) {
      api.createRecord('1641b27a', component.options)
    } else {
      api.reload('1641b27a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=1641b27a&", function () {
      api.rerender('1641b27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28nSOcv14a224/JS/comp/IncreaseNumber.vue"
export default component.exports